import { Injectable } from '@angular/core';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root',
})
export class ModalsTopbarService {
    modalRef: NgbModalRef;

    constructor(private modalService: NgbModal) {}

    open(content, option): NgbModalRef {
        // Retornamos a referência para que a barra superior consiga tratar
        // o motivo de fechamento, como a troca entre login e cadastro.
        this.modalRef = this.modalService.open(content, option);
        return this.modalRef;
    }

    close() {
        if (this.modalRef) this.modalRef.close();
    }
}
